import { render, staticRenderFns } from "./transDiag.vue?vue&type=template&id=30ef0ff2&scoped=true&"
import script from "./transDiag.vue?vue&type=script&lang=js&"
export * from "./transDiag.vue?vue&type=script&lang=js&"
import style0 from "./transDiag.vue?vue&type=style&index=0&id=30ef0ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef0ff2",
  null
  
)

export default component.exports